import variables from '../../../../variables';
import {$dom} from '../../../../helpers/dom';
import Scrollbar from 'smooth-scrollbar';
import {$events} from '../../../../helpers/events';
import vars from './vars';
import gsap from 'gsap';
import {$ui} from '../../../../helpers/ui';
import catalogAsideToggleHidden from './hiddenToggle';
import catalogStickyAside from './stickyAside';

const breakpoint = variables.breakpoints.lg;

const {
	get,
	hasClass,
	removeClass,
	addClass
} = $dom;

const {
	toggleButtonSelector,
	asideSelector,
	asideInnerSelector,
	showResultButtonSelector
} = vars;

const {
	active
} = variables.classNames;

let
	mainScrollElement,
	mainScrollBar,
	aside,
	scrollBlocked = false
;

gsap.defaults({duration: variables.gsapDefaultDuration});

function showFilter(immediately = false) {
	gsap[immediately ? 'set' : 'to'](asideSelector, {
		autoAlpha: 1,
		scaleX: 1,
		transformOrigin: 'right center'
	});

	$ui.blockScroll('enable');
	scrollBlocked = true
}

function hideFilter(immediately = false) {
	gsap[immediately ? 'set' : 'to'](asideSelector, {
		autoAlpha: 0,
		scaleX: .75,
		transformOrigin: 'right center'
	});

	if (scrollBlocked) {
		$ui.blockScroll('disable');
		scrollBlocked = false;
	}
}

function toggleFilterVisibility() {
	if (hasClass(aside, active)) {

		hideFilter();
		removeClass(aside, active);
	} else {

		showFilter();
		addClass(aside, active);
	}
}

function hideBySwipe() {
	hideFilter();
	removeClass(aside, active);
}

function resetAsideStyles() {
	gsap.set(asideSelector, {
		clearProps: 'opacity,visibility,scaleX',
		onComplete() {
			$ui.blockScroll('disable');
			scrollBlocked = false;
			removeClass(aside, active);
		}
	});
}



function setShowResultsButtonView(view) {
	const innerButtonSelector = `${showResultButtonSelector} .button`;

	gsap.set(showResultButtonSelector, {clearProps: 'height'});
	gsap.set(innerButtonSelector, {clearProps: 'width'});

	switch (view) {
		case 'mobile':

			gsap.set(showResultButtonSelector, {
				height: gsap.getProperty(showResultButtonSelector, 'height')
			});
			gsap.set(innerButtonSelector, {
				width: gsap.getProperty(showResultButtonSelector, 'width')
			});
			addClass(showResultButtonSelector, 'is-fixed');
			break;

		case 'desktop':
			removeClass(showResultButtonSelector, 'is-fixed');
			break;
	}

}

const updateAsideInnerHeight = $events.debounce(function () {
	gsap.set(asideInnerSelector, {
		height: variables.windowHeight + 'px'
	});
});

export default function catalogFilterView() {

	const
		hiddenPart = catalogAsideToggleHidden(),
		stickyAside = catalogStickyAside(),
		getView = () => variables.windowWidth < breakpoint ? 'mobile' : 'desktop',
		update = () => {
			$events.delegate
				.off('tap', toggleButtonSelector, toggleFilterVisibility)
				.off('swipeRight', asideSelector, hideBySwipe)
				.off('resize', window, updateAsideInnerHeight)
			;

			const view = getView();

			setShowResultsButtonView(view);

			switch (view) {
				case 'mobile':
					$events.delegate
						.on('tap', toggleButtonSelector, toggleFilterVisibility)
						.on('swipeRight', asideSelector, hideBySwipe)
						.on('resize', window, updateAsideInnerHeight)
					;
					hideFilter(true);
					removeClass(aside, active);

					updateAsideInnerHeight();
					break;
				case 'desktop':

					resetAsideStyles();
					break;
			}

		},
		init = () => {
			mainScrollElement = get('#'+variables.selectors.mainScrollElementId);
			mainScrollBar = Scrollbar.get(mainScrollElement);
			aside = get(asideSelector);

			hiddenPart.init();
			stickyAside.init();

			switch (getView()) {
				case 'mobile':
					updateAsideInnerHeight();
					hideFilter(true);
					break;
				case 'desktop':

					break;
			}

			update();
			$events.resize('on', update);
		},
		destroy = () => {
			mainScrollElement = null;
			mainScrollBar = null;
			aside = null;

			hiddenPart.destroy();
			stickyAside.destroy();

			$events.delegate
				.off('tap', toggleButtonSelector, toggleFilterVisibility)
				.off('swipeRight', asideSelector, hideBySwipe)
				.off('resize', window, updateAsideInnerHeight)
			;

			$events.resize('off', update);
		}
	;

	return {
		init, destroy, showFilter, hideFilter
	}
}


